/**
 * Markdown Configuration
 *
 * Shared Streamdown v2 plugin configuration for consistent markdown rendering
 * across both streaming and completed messages.
 *
 * v2 includes GFM, raw HTML, and sanitization by default.
 * Only math needs explicit setup via @streamdown/math.
 */

import { createMathPlugin } from "@streamdown/math";

/**
 * Math plugin — renders LaTeX equations via KaTeX.
 * Single $ parsing disabled to preserve $ for dollar price values.
 */
export const mathPlugin = createMathPlugin({
  singleDollarTextMath: false,
});
